import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { PersonnelActions } from './personnel.actions';
import { PersonnelEntity } from './personnel.entity';
import { mergeWith } from 'lodash-es';
import { Helper } from '@core/util';

export const PERSONNEL_FEATURE_KEY = 'personnel';

export interface PersonnelState extends EntityState<PersonnelEntity> {
  selectedId?: string; // which Personnel record has been selected
  loaded: boolean; // has the Personnel list been loaded
  error?: string | null; // last known error (if any)
}

export interface PersonnelPartialState {
  readonly [PERSONNEL_FEATURE_KEY]: PersonnelState;
}

export const personnelAdapter: EntityAdapter<PersonnelEntity> = createEntityAdapter<PersonnelEntity>();

export const initialPersonnelState: PersonnelState = personnelAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialPersonnelState,
  on(PersonnelActions.init, state => ({ ...state, loaded: false, error: null })),
  on(PersonnelActions.loadSuccess, (state, { entities, selectedId }) => {
    const data = { ...state, loaded: true };
    selectedId && (data.selectedId = selectedId);
    return personnelAdapter.setAll(entities, data);
  }),
  on(PersonnelActions.loadFailure, (state, { error }) => ({ ...state, error })),
  on(PersonnelActions.setCurrentPersonnel, (state, { personnel }) => {
    if (state.selectedId && state.selectedId === personnel.entityId) {
      const { selectEntities } = personnelAdapter.getSelectors();
      const entities = selectEntities(state);
      const personnelEntity = entities[state.selectedId];

      if (personnelEntity) {
        const merged = mergeWith({}, personnelEntity.data, personnel, Helper.mergeDeepWithoutMergeArray);
        // console.log({ personnelEntity: personnelEntity.data, currentPersonnel: personnel, merged });

        // return personnelAdapter.updateOne(
        //   {
        //     id: state.selectedId,
        //     changes: { ...personnelEntity, data: merged },
        //   },
        //   state,
        // );
      }

      return state;
    }

    return state;
  }),
);

export function personnelReducer(state: PersonnelState | undefined, action: Action) {
  return reducer(state, action);
}
